import { TEMPLATE_TYPES, type TEMPLATE_TYPE } from './template.js';

export const ETA_PLACEHOLDER = {
    ANREDE: 'anrede',
    NACHNAME: 'nachname',
    VORNAME: 'vorname',
    ANREDE_BENUTZER: 'anredeBenutzer',
    NACHNAME_BENUTZER: 'nachnameBenutzer',
    VORNAME_BENUTZER: 'vornameBenutzer',
    FREITEXT: 'freitext',
    EMAIL_BERATER: 'emailBerater',
    TELEFON_BERATER: 'telefonBerater',
    ANREDE_BERATER: 'anredeBerater',
    NACHNAME_BERATER: 'nachnameBerater',
    VORNAME_BERATER: 'vornameBerater',
    MAIL_ID: 'mailId',
    MAIL_VERSION_ID: 'mailVersionId',
    FIRST_PARTY_ID: 'firstPartyId',
    APPLICANT_ID: 'applicantId',
    LINK_NAME: 'linkName',
    URL: 'url',
    TITEL_BERATER: 'titelBerater',
    DOKUMENTE: 'dokumente',
    NAME_ANTRAGSTELLER_1: 'nameAntragsteller1',
    ANGEBOT_KREDITBETRAG: 'angebotKreditbetrag',
    ANGEBOT_BANK: 'angebotBank',
    ANGEBOT_EFFEKTIVZINSSATZ: 'angebotEffektivzinsSatz',
    ANGEBOT_MONATLICHE_RATE: 'angebotMonatlicheRate',
    ANGEBOT_LAUFZEIT: 'angebotLaufzeit',
    ANGEBOT_SOLLZINS: 'angebotSollzins',
    ANGEBOT_AUSZAHLUNGSBETRAG: 'angebotAuszahlungsbetrag',
    ANGEBOT_ABSICHERUNG_ANTRAGSTELLER_1: 'angebotAbsicherungAntragsteller1',
    ANGEBOT_ABSICHERUNG_ANTRAGSTELLER_2: 'angebotAbsicherungAntragsteller2',
    ANGEBOTE_TEXT: 'angeboteText',
    ANGEBOTE_HTML: 'angeboteHtml',
    TRUSTPILOT_LINK: 'trustpilotLink',
} as const satisfies Record<string, string>;
export type ETA_PLACEHOLDER_TYPE = typeof ETA_PLACEHOLDER;
export const ETA_ADVISER_PLACEHOLDERS = [
    ETA_PLACEHOLDER.ANREDE_BERATER,
    ETA_PLACEHOLDER.TITEL_BERATER,
    ETA_PLACEHOLDER.EMAIL_BERATER,
    ETA_PLACEHOLDER.TELEFON_BERATER,
    ETA_PLACEHOLDER.NACHNAME_BERATER,
    ETA_PLACEHOLDER.VORNAME_BERATER,
] as const;
export const ETA_TRACKING_PLACEHOLDERS = [
    ETA_PLACEHOLDER.MAIL_ID,
    ETA_PLACEHOLDER.MAIL_VERSION_ID,
    ETA_PLACEHOLDER.FIRST_PARTY_ID,
    ETA_PLACEHOLDER.APPLICANT_ID,
    ETA_PLACEHOLDER.LINK_NAME,
] as const;
export const ETA_SYSTEM_MAIL_PLACEHOLDERS = {
    system_applicant_advertisement_consent: [
        ETA_PLACEHOLDER.URL,
        ETA_PLACEHOLDER.VORNAME,
        ETA_PLACEHOLDER.NACHNAME,
        ETA_PLACEHOLDER.ANREDE,
        ...ETA_TRACKING_PLACEHOLDERS,
    ],
    system_applicant_advertisement_consent_with_info: [
        ETA_PLACEHOLDER.URL,
        ETA_PLACEHOLDER.VORNAME,
        ETA_PLACEHOLDER.NACHNAME,
        ETA_PLACEHOLDER.ANREDE,
        ...ETA_TRACKING_PLACEHOLDERS,
    ],
    system_applicant_co_verification: [
        ETA_PLACEHOLDER.URL,
        ETA_PLACEHOLDER.VORNAME,
        ETA_PLACEHOLDER.NACHNAME,
        ETA_PLACEHOLDER.ANREDE,
        ETA_PLACEHOLDER.NAME_ANTRAGSTELLER_1,
        ...ETA_TRACKING_PLACEHOLDERS,
    ],
    system_applicant_data_protection_agreement_requested: [
        ETA_PLACEHOLDER.URL,
        ETA_PLACEHOLDER.VORNAME,
        ETA_PLACEHOLDER.NACHNAME,
        ETA_PLACEHOLDER.ANREDE,
        ...ETA_TRACKING_PLACEHOLDERS,
    ],
    system_applicant_documents_demanded: [
        ETA_PLACEHOLDER.URL,
        ETA_PLACEHOLDER.VORNAME,
        ETA_PLACEHOLDER.NACHNAME,
        ETA_PLACEHOLDER.ANREDE,
        ETA_PLACEHOLDER.DOKUMENTE,
        ...ETA_ADVISER_PLACEHOLDERS,
        ...ETA_TRACKING_PLACEHOLDERS,
    ],
    system_applicant_documents_demanded_reminded: [
        ETA_PLACEHOLDER.URL,
        ETA_PLACEHOLDER.VORNAME,
        ETA_PLACEHOLDER.NACHNAME,
        ETA_PLACEHOLDER.ANREDE,
        ETA_PLACEHOLDER.DOKUMENTE,
        ...ETA_ADVISER_PLACEHOLDERS,
        ...ETA_TRACKING_PLACEHOLDERS,
    ],
    system_applicant_info: [
        ETA_PLACEHOLDER.VORNAME,
        ETA_PLACEHOLDER.NACHNAME,
        ETA_PLACEHOLDER.ANREDE,
        ...ETA_TRACKING_PLACEHOLDERS,
    ],
    system_applicant_verification: [
        ETA_PLACEHOLDER.URL,
        ETA_PLACEHOLDER.VORNAME,
        ETA_PLACEHOLDER.NACHNAME,
        ETA_PLACEHOLDER.ANREDE,
        ...ETA_TRACKING_PLACEHOLDERS,
    ],
    system_loan_request_customer_cancel_reason_financing_request_expired: [
        ETA_PLACEHOLDER.VORNAME,
        ETA_PLACEHOLDER.NACHNAME,
        ETA_PLACEHOLDER.ANREDE,
        ...ETA_ADVISER_PLACEHOLDERS,
        ...ETA_TRACKING_PLACEHOLDERS,
    ],
    system_loan_request_customer_cancel_reason_not_reached: [
        ETA_PLACEHOLDER.VORNAME,
        ETA_PLACEHOLDER.NACHNAME,
        ETA_PLACEHOLDER.ANREDE,
        ...ETA_ADVISER_PLACEHOLDERS,
        ...ETA_TRACKING_PLACEHOLDERS,
    ],
    system_loan_request_data_deletion_cancel_reason: [
        ETA_PLACEHOLDER.VORNAME,
        ETA_PLACEHOLDER.NACHNAME,
        ETA_PLACEHOLDER.ANREDE,
        ...ETA_TRACKING_PLACEHOLDERS,
    ],
    system_loan_request_mediator_document_review_cancel_reason: [
        ETA_PLACEHOLDER.VORNAME,
        ETA_PLACEHOLDER.NACHNAME,
        ETA_PLACEHOLDER.ANREDE,
        ...ETA_ADVISER_PLACEHOLDERS,
        ...ETA_TRACKING_PLACEHOLDERS,
    ],
    system_loan_request_mediator_financial_cancel_reason: [
        ETA_PLACEHOLDER.VORNAME,
        ETA_PLACEHOLDER.NACHNAME,
        ETA_PLACEHOLDER.ANREDE,
        ...ETA_ADVISER_PLACEHOLDERS,
        ...ETA_TRACKING_PLACEHOLDERS,
    ],
    system_loan_request_mediator_personal_cancel_reason: [
        ETA_PLACEHOLDER.VORNAME,
        ETA_PLACEHOLDER.NACHNAME,
        ETA_PLACEHOLDER.ANREDE,
        ...ETA_ADVISER_PLACEHOLDERS,
        ...ETA_TRACKING_PLACEHOLDERS,
    ],
    system_loan_request_mediator_professional_cancel_reason: [
        ETA_PLACEHOLDER.VORNAME,
        ETA_PLACEHOLDER.NACHNAME,
        ETA_PLACEHOLDER.ANREDE,
        ...ETA_ADVISER_PLACEHOLDERS,
        ...ETA_TRACKING_PLACEHOLDERS,
    ],
    system_user_2fa_resetted: [
        ETA_PLACEHOLDER.URL,
        ETA_PLACEHOLDER.VORNAME_BENUTZER,
        ETA_PLACEHOLDER.NACHNAME_BENUTZER,
        ETA_PLACEHOLDER.ANREDE_BENUTZER,
    ],
    system_user_password_resetted: [
        ETA_PLACEHOLDER.URL,
        ETA_PLACEHOLDER.VORNAME_BENUTZER,
        ETA_PLACEHOLDER.NACHNAME_BENUTZER,
        ETA_PLACEHOLDER.ANREDE_BENUTZER,
    ],
    system_user_registered: [
        ETA_PLACEHOLDER.URL,
        ETA_PLACEHOLDER.VORNAME_BENUTZER,
        ETA_PLACEHOLDER.NACHNAME_BENUTZER,
        ETA_PLACEHOLDER.ANREDE_BENUTZER,
    ],
} as const;
export const ETA_SIGNATURE_PLACEHOLDERS = ETA_ADVISER_PLACEHOLDERS;
export const ETA_OFFER_PLACEHOLDERS = [
    ETA_PLACEHOLDER.ANGEBOT_BANK,
    ETA_PLACEHOLDER.ANGEBOT_KREDITBETRAG,
    ETA_PLACEHOLDER.ANGEBOT_LAUFZEIT,
    ETA_PLACEHOLDER.ANGEBOT_MONATLICHE_RATE,
    ETA_PLACEHOLDER.ANGEBOT_EFFEKTIVZINSSATZ,
    ETA_PLACEHOLDER.ANGEBOT_SOLLZINS,
    ETA_PLACEHOLDER.ANGEBOT_AUSZAHLUNGSBETRAG,
    ETA_PLACEHOLDER.ANGEBOT_ABSICHERUNG_ANTRAGSTELLER_1,
    ETA_PLACEHOLDER.ANGEBOT_ABSICHERUNG_ANTRAGSTELLER_2,
    ETA_PLACEHOLDER.FREITEXT,
] as const;
export const ETA_PLACEHOLDERS = [
    ETA_PLACEHOLDER.ANREDE,
    ETA_PLACEHOLDER.NACHNAME,
    ETA_PLACEHOLDER.VORNAME,
    ETA_PLACEHOLDER.ANGEBOTE_TEXT,
    ETA_PLACEHOLDER.ANGEBOTE_HTML,
    ETA_PLACEHOLDER.FREITEXT,
    ETA_PLACEHOLDER.TRUSTPILOT_LINK,
    ...ETA_ADVISER_PLACEHOLDERS,
    ...ETA_TRACKING_PLACEHOLDERS,
] as const;
export const ETA_DIVISION_PLACEHOLDERS = [
    ETA_PLACEHOLDER.ANREDE,
    ETA_PLACEHOLDER.NACHNAME,
    ETA_PLACEHOLDER.VORNAME,
    ETA_PLACEHOLDER.FREITEXT,
    ETA_PLACEHOLDER.TRUSTPILOT_LINK,
    ...ETA_ADVISER_PLACEHOLDERS,
    ...ETA_TRACKING_PLACEHOLDERS,
] as const;
export type ETA_DIVISION_PLACEHOLDERS = Omit<
    (typeof ETA_PLACEHOLDERS)[number],
    typeof ETA_PLACEHOLDER.ANGEBOTE_HTML | typeof ETA_PLACEHOLDER.ANGEBOTE_TEXT
>;
export const ETA_VERIFICATION_PLACEHOLDERS = ETA_SYSTEM_MAIL_PLACEHOLDERS.system_applicant_verification;
export const ETA_ADVERTISEMENT_CONSENT_PLACEHOLDERS =
    ETA_SYSTEM_MAIL_PLACEHOLDERS.system_applicant_advertisement_consent;
export const ETA_ADVERTISEMENT_CONSENT_WITH_INFO_PLACEHOLDERS =
    ETA_SYSTEM_MAIL_PLACEHOLDERS.system_applicant_advertisement_consent_with_info;
export const ETA_DATA_CONSENT_PLACEHOLDERS =
    ETA_SYSTEM_MAIL_PLACEHOLDERS.system_applicant_data_protection_agreement_requested;
export const ETA_DOCUMENT_DEMANDED_PLACEHOLDERS = [
    ...ETA_SYSTEM_MAIL_PLACEHOLDERS.system_applicant_documents_demanded,
    ...ETA_SYSTEM_MAIL_PLACEHOLDERS.system_applicant_documents_demanded_reminded,
];
export const ETA_INFO_PLACEHOLDERS = ETA_SYSTEM_MAIL_PLACEHOLDERS.system_applicant_info;
export const ETA_CO_VERIFICATION_PLACEHOLDERS = ETA_SYSTEM_MAIL_PLACEHOLDERS.system_applicant_co_verification;
export const ETA_LEAD_CANCELED_PLACEHOLDERS = [
    ...ETA_SYSTEM_MAIL_PLACEHOLDERS.system_loan_request_customer_cancel_reason_not_reached,
    ...ETA_SYSTEM_MAIL_PLACEHOLDERS.system_loan_request_customer_cancel_reason_financing_request_expired,
    ...ETA_SYSTEM_MAIL_PLACEHOLDERS.system_loan_request_mediator_professional_cancel_reason,
    ...ETA_SYSTEM_MAIL_PLACEHOLDERS.system_loan_request_mediator_personal_cancel_reason,
    ...ETA_SYSTEM_MAIL_PLACEHOLDERS.system_loan_request_mediator_financial_cancel_reason,
    ...ETA_SYSTEM_MAIL_PLACEHOLDERS.system_loan_request_mediator_document_review_cancel_reason,
    ...ETA_SYSTEM_MAIL_PLACEHOLDERS.system_loan_request_data_deletion_cancel_reason,
];
export type ETA_PLACEHOLDERS = (typeof ETA_PLACEHOLDERS)[number];
export type ETA_ADVISER_PLACEHOLDERS = (typeof ETA_ADVISER_PLACEHOLDERS)[number];
export type ETA_TRACKING_PLACEHOLDERS = (typeof ETA_TRACKING_PLACEHOLDERS)[number];
export type ETA_OFFER_PLACEHOLDERS = (typeof ETA_OFFER_PLACEHOLDERS)[number];
export type ETA_ADVERTISEMENT_CONSENT_PLACEHOLDERS = (typeof ETA_ADVERTISEMENT_CONSENT_PLACEHOLDERS)[number];
export type ETA_ADVERTISEMENT_CONSENT_WITH_INFO_PLACEHOLDERS =
    (typeof ETA_ADVERTISEMENT_CONSENT_WITH_INFO_PLACEHOLDERS)[number];
export type ETA_VERIFICATION_PLACEHOLDERS = (typeof ETA_VERIFICATION_PLACEHOLDERS)[number];
export type ETA_CO_VERIFICATION_PLACEHOLDERS = (typeof ETA_CO_VERIFICATION_PLACEHOLDERS)[number];
export type ETA_LEAD_CANCELED_PLACEHOLDERS = (typeof ETA_LEAD_CANCELED_PLACEHOLDERS)[number];
export type ETA_INFO_PLACEHOLDERS = (typeof ETA_INFO_PLACEHOLDERS)[number];
export type ETA_DATA_CONSENT_PLACEHOLDERS = (typeof ETA_DATA_CONSENT_PLACEHOLDERS)[number];
export type ETA_DOCUMENTS_DEMANDED_PLACEHOLDERS = (typeof ETA_DOCUMENT_DEMANDED_PLACEHOLDERS)[number];
export type ETA_SIGNATURE_PLACEHOLDERS = (typeof ETA_SIGNATURE_PLACEHOLDERS)[number];
export type ETA_HEADER_FOOTER_PLACEHOLDERS = (typeof ETA_HEADER_FOOTER_PLACEHOLDERS)[number];
export type ETA_DIVISION_PLACEHOLDERS_OBJECT = Record<(typeof ETA_DIVISION_PLACEHOLDERS)[number], string>;
export type ETA_PLACEHOLDERS_OBJECT = Record<ETA_PLACEHOLDERS, string>;
export type ETA_ADVISER_PLACEHOLDERS_OBJECT = Record<ETA_ADVISER_PLACEHOLDERS, string>;
export type ETA_TRACKING_PLACEHOLDERS_OBJECT = Record<ETA_TRACKING_PLACEHOLDERS, string>;
export type ETA_OFFER_PLACEHOLDERS_OBJECT = Record<ETA_OFFER_PLACEHOLDERS, string>;
export type ETA_ADVERTISEMENT_CONSENT_PLACEHOLDERS_OBJECT = Record<ETA_ADVERTISEMENT_CONSENT_PLACEHOLDERS, string>;
export type ETA_ADVERTISEMENT_CONSENT_WITH_INFO_PLACEHOLDERS_OBJECT = Record<
    ETA_ADVERTISEMENT_CONSENT_WITH_INFO_PLACEHOLDERS,
    string
>;
export type ETA_VERIFICATION_PLACEHOLDERS_OBJECT = Record<ETA_VERIFICATION_PLACEHOLDERS, string>;
export type ETA_CO_VERIFICATION_PLACEHOLDERS_OBJECT = Record<ETA_CO_VERIFICATION_PLACEHOLDERS, string>;
export type ETA_LEAD_CANCELED_PLACEHOLDERS_OBJECT = Record<ETA_LEAD_CANCELED_PLACEHOLDERS, string>;
export type ETA_INFO_PLACEHOLDERS_OBJECT = Record<ETA_INFO_PLACEHOLDERS, string>;
export type ETA_DATA_CONSENT_PLACEHOLDERS_OBJECT = Record<ETA_DATA_CONSENT_PLACEHOLDERS, string>;
export type ETA_DOCUMENT_DEMANDED_PLACEHOLDERS_OBJECT = Record<
    ETA_DOCUMENTS_DEMANDED_PLACEHOLDERS,
    string | { html: string; txt: string }
>;
export const ETA_HEADER_FOOTER_PLACEHOLDERS = [...ETA_ADVISER_PLACEHOLDERS, ...ETA_TRACKING_PLACEHOLDERS];
export const ETA_CANCELLATION_TEMPLATES_PLACEHOLDERS = [ETA_PLACEHOLDER.ANREDE, ETA_PLACEHOLDER.NACHNAME] as const;
// legacy ##token## syntax, case-insensitive so hand-typed ##Vorname## is caught too
export const OLD_MAIL_PLACEHOLDER_REGEX = /##[a-z][a-z0-9-]*##/i;
export type ETA_PLACEHOLDER_CATEGORY =
    | typeof ETA_PLACEHOLDERS
    | typeof ETA_SIGNATURE_PLACEHOLDERS
    | typeof ETA_OFFER_PLACEHOLDERS
    | typeof ETA_HEADER_FOOTER_PLACEHOLDERS
    | (typeof ETA_SYSTEM_MAIL_PLACEHOLDERS)[keyof typeof ETA_SYSTEM_MAIL_PLACEHOLDERS]
    | ReadonlyArray<(typeof ETA_PLACEHOLDERS)[number] | (typeof ETA_OFFER_PLACEHOLDERS)[number]>;
export type ETA_PLACEHOLDER_LIST = Array<
    | (typeof ETA_PLACEHOLDERS)[number]
    | (typeof ETA_SIGNATURE_PLACEHOLDERS)[number]
    | (typeof ETA_HEADER_FOOTER_PLACEHOLDERS)[number]
    | (typeof ETA_OFFER_PLACEHOLDERS)[number]
    | (typeof ETA_SYSTEM_MAIL_PLACEHOLDERS)[keyof typeof ETA_SYSTEM_MAIL_PLACEHOLDERS][number]
>;

// TODO add DIVISION_PLACEHOLDERS when we have specific placeholders for division templates
export const ETA_PLACEHOLDERS_FROM_LIST: Record<ETA_PLACEHOLDER_LIST[number], boolean> = {
    ...ETA_PLACEHOLDERS.reduce(
        (acc, placeholder) => ({ ...acc, [placeholder]: false }),
        {} as Record<(typeof ETA_PLACEHOLDERS)[number], boolean>,
    ),
    ...ETA_HEADER_FOOTER_PLACEHOLDERS.reduce(
        (acc, placeholder) => ({ ...acc, [placeholder]: false }),
        {} as Record<(typeof ETA_HEADER_FOOTER_PLACEHOLDERS)[number], boolean>,
    ),
    ...ETA_SIGNATURE_PLACEHOLDERS.reduce(
        (acc, placeholder) => ({ ...acc, [placeholder]: false }),
        {} as Record<(typeof ETA_SIGNATURE_PLACEHOLDERS)[number], boolean>,
    ),
    ...ETA_OFFER_PLACEHOLDERS.reduce(
        (acc, placeholder) => ({ ...acc, [placeholder]: false }),
        {} as Record<(typeof ETA_OFFER_PLACEHOLDERS)[number], boolean>,
    ),
    ...Object.entries(ETA_SYSTEM_MAIL_PLACEHOLDERS)
        .flatMap(([_, placeholders]) => placeholders.map((placeholder) => [placeholder, false] as const))
        .reduce(
            (acc, [key, value]) => (typeof key === 'boolean' ? acc : { ...acc, [key]: value }),
            {} as Record<
                (typeof ETA_SYSTEM_MAIL_PLACEHOLDERS)[keyof typeof ETA_SYSTEM_MAIL_PLACEHOLDERS][number],
                boolean
            >,
        ),
};

// placeholders the save-time eta check provides per template type (body fields; offer items use ETA_OFFER_PLACEHOLDERS)
export const ETA_TEMPLATE_TYPE_PLACEHOLDERS = {
    [TEMPLATE_TYPES.DIVISION_FOOTER]: ETA_HEADER_FOOTER_PLACEHOLDERS,
    [TEMPLATE_TYPES.DIVISION_HEADER]: ETA_HEADER_FOOTER_PLACEHOLDERS,
    [TEMPLATE_TYPES.DIVISION_MAIL]: ETA_DIVISION_PLACEHOLDERS,
    [TEMPLATE_TYPES.MAIL]: ETA_PLACEHOLDERS,
    [TEMPLATE_TYPES.MAIL_FOOTER]: ETA_HEADER_FOOTER_PLACEHOLDERS,
    [TEMPLATE_TYPES.MAIL_HEADER]: ETA_HEADER_FOOTER_PLACEHOLDERS,
    [TEMPLATE_TYPES.MAIL_SIGNATURE]: ETA_SIGNATURE_PLACEHOLDERS,
    [TEMPLATE_TYPES.OFFER_MAIL]: ETA_PLACEHOLDERS,
    [TEMPLATE_TYPES.SYSTEM_MAIL]: [],
} as const satisfies Record<TEMPLATE_TYPE, ReadonlyArray<ETA_PLACEHOLDER_LIST[number]>>;

export const ETA_TEMPLATE_ERROR_KINDS = {
    LEGACY_PLACEHOLDER: 'LEGACY_PLACEHOLDER',
    SYNTAX: 'SYNTAX',
} as const;

export const ETA_TEMPLATE_FIELDS = {
    HTML: 'mailHTMLContent',
    OFFER_HTML: 'offerItemHTMLContent',
    OFFER_TEXT: 'offerItemContent',
    SUBJECT: 'subject',
    TEXT: 'mailContent',
} as const;
